import { render, staticRenderFns } from "./SimpleAverageData.vue?vue&type=template&id=f5859af2&scoped=true"
import script from "./SimpleAverageData.vue?vue&type=script&lang=js"
export * from "./SimpleAverageData.vue?vue&type=script&lang=js"
import style0 from "./SimpleAverageData.vue?vue&type=style&index=0&id=f5859af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5859af2",
  null
  
)

export default component.exports